import { useMemo, useState, useCallback } from 'react'

const INITIAL_FILTERS = {
  enrollmentStatuses: [],
  genders: [],
  categoryIds: [],
  courseIds: [],
  eventIds: [],
  levels: [],
  dateJoinedFrom: null,
  dateJoinedTo: null,
  ageFrom: null,
  ageTo: null,
}

export const countFilterValues = (filters) =>
  filters.enrollmentStatuses.length
    + filters.genders.length
    + filters.categoryIds.length
    + filters.courseIds.length
    + filters.eventIds.length
    + filters.levels.length
    + (filters.dateJoinedFrom ? 1 : 0)
    + (filters.dateJoinedTo ? 1 : 0)
    + (filters.ageFrom !== null ? 1 : 0)
    + (filters.ageTo !== null ? 1 : 0)

const arrayDiffCount = (a, b) => {
  const added = b.filter(v => !a.includes(v)).length
  const removed = a.filter(v => !b.includes(v)).length
  return added + removed
}

export const countFilterChanges = (applied, pending) => arrayDiffCount(applied.enrollmentStatuses, pending.enrollmentStatuses)
    + arrayDiffCount(applied.genders, pending.genders)
    + arrayDiffCount(applied.categoryIds, pending.categoryIds)
    + arrayDiffCount(applied.courseIds, pending.courseIds)
    + arrayDiffCount(applied.eventIds, pending.eventIds)
    + arrayDiffCount(applied.levels, pending.levels)
    + (applied.dateJoinedFrom !== pending.dateJoinedFrom ? 1 : 0)
    + (applied.dateJoinedTo !== pending.dateJoinedTo ? 1 : 0)
    + (applied.ageFrom !== pending.ageFrom ? 1 : 0)
    + (applied.ageTo !== pending.ageTo ? 1 : 0)

export const buildApiFilters = (filters) => {
  const params = {}

  if (filters.enrollmentStatuses.length) { params.enrollmentStatuses = filters.enrollmentStatuses }
  if (filters.genders.length) { params.genders = filters.genders }
  if (filters.categoryIds.length) { params.categoryIds = filters.categoryIds }
  if (filters.courseIds.length) { params.courseIds = filters.courseIds }
  if (filters.eventIds.length) { params.eventIds = filters.eventIds }
  if (filters.levels.length) { params.levels = filters.levels }
  if (filters.dateJoinedFrom) { params.dateJoinedFrom = filters.dateJoinedFrom }
  if (filters.dateJoinedTo) { params.dateJoinedTo = filters.dateJoinedTo }
  if (filters.ageFrom !== null) { params.ageFrom = filters.ageFrom }
  if (filters.ageTo !== null) { params.ageTo = filters.ageTo }

  return params
}

const useStudentsFilters = () => {
  const [filters, setFilters] = useState(INITIAL_FILTERS)

  const apiFilters = useMemo(() => buildApiFilters(filters), [filters])

  const activeFilterCount = useMemo(() => countFilterValues(filters), [filters])

  const applyFilters = useCallback((newFilters) => {
    setFilters(newFilters)
  }, [])

  const clearFilters = useCallback(() => {
    setFilters(INITIAL_FILTERS)
  }, [])

  return {
    filters,
    apiFilters,
    activeFilterCount,
    applyFilters,
    clearFilters,
    INITIAL_FILTERS,
  }
}

export default useStudentsFilters
